import { createSlice, createSelector } from '@reduxjs/toolkit';
import { logout } from "../common/reducers/initContext";
import { dataHookFactory, initMapFactory } from '../common/reducers/utilities';
import { ensureArray } from '../common/utils/arrayUtilities';

const compareAccessRequests = (a1, a2) => a1.internalid === a2.internalid;

const jobAccessRequestsSlice = createSlice({
    name: 'jobAccessRequests',
    initialState: {
        data: {}
    },
    reducers: {
        set: (state, action) => {
            let data = ensureArray(action.payload);
            data.forEach(dt => {
                delete state.data[dt.jobid];
            })
            data.forEach(dt => {
                const jobid = dt.jobid;
                if (!state.data[jobid]) {
                    state.data[jobid] = []
                }
                state.data[jobid].push(dt);
            });
        },
        addOrUpdate: (state, action) => {
            for (const request of ensureArray(action.payload)) {
                const jobid = request.jobid;
                if (state.data[jobid]) {
                    let idx = state.data[jobid].findIndex(a => compareAccessRequests(a, request));
                    if (idx >= 0) {
                        state.data[jobid].splice(idx, 1, request);
                    } else {
                        state.data[jobid].push(request);
                    }
                } else {
                    state.data[jobid] = [request];
                }
            }
        },
        remove: (state, action) => {
            for (const request of ensureArray(action.payload)) {
                const jobid = request.jobid;
                if (state.data[jobid]) {
                    let idx = state.data[jobid].findIndex(a => compareAccessRequests(a, request));
                    if (idx >= 0) {
                        state.data[jobid].splice(idx, 1);
                    }
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => jobAccessRequestsSlice.getInitialState());
    }
});

// #region network operations
const fetchJobccessRequests = jobid => network => network.get('/api/v1/jobAccessRequests/' + encodeURIComponent(jobid), jobAccessRequestsSlice.actions.set);
export const requestJobAccess = (network, request) => network.post('/api/v1/jobAccessRequests', request, jobAccessRequestsSlice.actions.addOrUpdate)
export const upateJobAccessRequest = (network, request) => network.put('/api/v1/jobAccessRequest', request, jobAccessRequestsSlice.actions.addOrUpdate)

// #endregion

// #region selectors
const selectAccessRequests = state => state.jobAccessRequests.data;

// we now make a reselect to memoize a select function parameterized by jobid and expose that factory through a convenience function
const selectAccessRequestsByJobID = jobid => createSelector([selectAccessRequests], requests => requests[jobid] ?? []);
// #endregion

// #region listeners
const listen = {
    jobAccessRequestAdded: (request, { dispatch }) => dispatch(jobAccessRequestsSlice.actions.addOrUpdate(request)),
    jobAccessRequestUpdated: (request, { dispatch }) => dispatch(jobAccessRequestsSlice.actions.addOrUpdate(request))
}
// #endregion

export const [useJobAccessRequests, realizeJobAccessRequests] = dataHookFactory(selectAccessRequestsByJobID, initMapFactory(fetchJobccessRequests, listen, jobid => jobid?.toString()));

const reducerDetails = { name: jobAccessRequestsSlice.name, reducer: jobAccessRequestsSlice.reducer };
export default reducerDetails;